//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("securityCheck", SecurityCheckFactory);

    SecurityCheckFactory.$inject = ["apiClientFactory"];
    function SecurityCheckFactory(apiClientFactory) {

        const routePrefix = "api/assistance-in/";

        return {
            BulkComplete: apiClientFactory.post(routePrefix + "security-checks/"),
            ForwardedLists: apiClientFactory.post(routePrefix + "forwarded-lists/"),
            GetForwardedList: apiClientFactory.get(routePrefix + "forwarded-lists/"),
            GetRequestsToConfirm: apiClientFactory.post(routePrefix + "requests/to-confirm/"),
            SaveSecurityCheckResult: apiClientFactory.put(routePrefix + "security-checks/"),
        };
    }
})();
